// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Role Stats Bar */
.role-stats-bar {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.role-stat-card {
  background: var(--color-parchment-100);

  /* Parchment texture */
  background-image:
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%);

  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-3);
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-fast);

  /* Reset button styles */
  font: inherit;
  appearance: none;
  -webkit-appearance: none;
}

.role-stat-card:hover {
  border-color: var(--color-fire-600);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.role-stat-card--active {
  border-color: var(--color-fire-600);
  background: var(--color-fire-600);
  box-shadow: var(--shadow-md);
}

.role-stat-card--active .role-stat-value,
.role-stat-card--active .role-stat-label {
  color: var(--color-parchment-100);
}

.role-stat-icon {
  font-size: 20px;
  margin-bottom: var(--space-1);
}

.role-stat-value {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: var(--color-fire-600);
  line-height: 1.2;
}

.role-stat-label {
  font-size: 11px;
  color: var(--color-text-secondary);
  margin-top: var(--space-1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/RoleStatsBar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;qFAGmF;;EAEnF,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;;EAEtC,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* Role Stats Bar */\n.role-stats-bar {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.role-stat-card {\n  background: var(--color-parchment-100);\n\n  /* Parchment texture */\n  background-image:\n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%);\n\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-3);\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n\n  /* Reset button styles */\n  font: inherit;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.role-stat-card:hover {\n  border-color: var(--color-fire-600);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.role-stat-card--active {\n  border-color: var(--color-fire-600);\n  background: var(--color-fire-600);\n  box-shadow: var(--shadow-md);\n}\n\n.role-stat-card--active .role-stat-value,\n.role-stat-card--active .role-stat-label {\n  color: var(--color-parchment-100);\n}\n\n.role-stat-icon {\n  font-size: 20px;\n  margin-bottom: var(--space-1);\n}\n\n.role-stat-value {\n  font-family: var(--font-heading);\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n  line-height: 1.2;\n}\n\n.role-stat-label {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  margin-top: var(--space-1);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
